<template>
  <div>
    <monitoring-disclaimer class="q-my-md" />

    <flagged-client-posts-toolbar
      :client="client"
      v-model:filters="filters"
    />
    <posts-view-options
      v-model:filters="filters"
      v-model:pagination-mode="paginationMode"
    >
      <flagged-client-posts-toolbar
        :client="client"
        v-model:filters="filters"
        :maximize-btn="{ flat: true }"
        minimized
      />
    </posts-view-options>

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
      highlight-flagged-words
    >
      <template v-slot="{ visiblePosts }">
        <posts-grid :posts="visiblePosts">
          <template v-slot="post">
            <post
              :post="post"
              :highlight="getHighlightRules(post)"
              notes
              trash
              actions
              scrollable
            />
          </template>
        </posts-grid>
      </template>
    </posts>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, Post as PostType, PostFilters } from '@/type';
import { status } from '@/social/post/post';
import MonitoringDisclaimer from '@/social/post/flagging/MonitoringDisclaimer.vue';
import PostsGrid from '@/social/post/list/PostsGrid.vue';
import Post from '@/social/post/card/Post.vue';
import { StringMatchRule } from '@/util/string';
import Posts from '../Posts.vue';
import FlaggedClientPostsToolbar from './FlaggedClientPostsToolbar.vue';
import PostsViewOptions from '../PostsViewOptions.vue';

interface Data {
  filters: PostFilters,
  paginationMode: 'scroll'
}

export default defineComponent({
  components: {
    PostsViewOptions,
    Post,
    PostsGrid,
    MonitoringDisclaimer,
    FlaggedClientPostsToolbar,
    Posts,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      filters: {
        clientIds: [this.client.id],
        statuses: [status.UNREVIEWED, status.SAVED, status.ESCALATED, status.RESOLVED],
        socialSiteIds: [],
        categoryIds: {},
        isFlagged: true,
        isTrashed: false,
        since: null,
        until: null,
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
  methods: {
    getHighlightRules(post: PostType): StringMatchRule[] {
      if (!post.flaggedWords) return [];
      return post.flaggedWords.map(word => ({
        operation: 'contains',
        needle: word,
      }));
    },
  },
});
</script>
